import { render, staticRenderFns } from "./EnableEmailModal.vue?vue&type=template&id=bbce20a6"
import script from "./EnableEmailModal.vue?vue&type=script&lang=js"
export * from "./EnableEmailModal.vue?vue&type=script&lang=js"
import style0 from "./EnableEmailModal.vue?vue&type=style&index=0&id=bbce20a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports